/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Ocr_Processing_FramesInputs */

const en_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processing OCR... ${i?.current}/${i?.total} frames`)
};

const fr_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traitement OCR... ${i?.current}/${i?.total} images`)
};

const de_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR-Verarbeitung... ${i?.current}/${i?.total} Frames`)
};

const it_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elaborazione OCR... ${i?.current}/${i?.total} frame`)
};

const ru_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обработка OCR... ${i?.current}/${i?.total} кадров`)
};

const es_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Procesando OCR... ${i?.current}/${i?.total} fotogramas`)
};

const zh_cn2_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在处理 OCR... ${i?.current}/${i?.total} 帧`)
};

const ja_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR処理中... ${i?.current}/${i?.total} フレーム`)
};

const hi_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`OCR प्रक्रिया जारी है... ${i?.current}/${i?.total} फ्रेम`)
};

const pt_pt2_ocr_processing_frames = /** @type {(inputs: Ocr_Processing_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processando OCR... quadros ${i?.current}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Processing OCR... {current}/{total} frames" |
*
* @param {Ocr_Processing_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_processing_frames = /** @type {((inputs: Ocr_Processing_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Processing_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_processing_frames(inputs)
	if (locale === "de") return de_ocr_processing_frames(inputs)
	if (locale === "it") return it_ocr_processing_frames(inputs)
	if (locale === "ru") return ru_ocr_processing_frames(inputs)
	if (locale === "es") return es_ocr_processing_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_processing_frames(inputs)
	if (locale === "ja") return ja_ocr_processing_frames(inputs)
	if (locale === "hi") return hi_ocr_processing_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_processing_frames(inputs)
	return en_ocr_processing_frames(inputs)
});